export default __webpack_public_path__ + "static/media/ico_arrow_up_blue.7c14ab40.svg";